export {
  default as studio,
  ReactComponent as Studio,
} from '@assets/icons/use-cases/studio.svg'    
